export default "__VITE_ASSET__fTFH36yM__"